import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  Concert,
  ConcertGrouped,
} from 'src/app/models/(item)/concert/Concert.model';
import { ConcertService } from 'src/app/services/app/concert.service';

@Component({
  selector: 'concert-grouped',
  templateUrl: './concert-grouped.component.html',
  styleUrls: ['./concert-grouped.component.css'],
})
export class ConcertGroupedComponent implements OnInit {
  concertGroupeds$: BehaviorSubject<ConcertGrouped[]> = new BehaviorSubject<
    ConcertGrouped[]
  >(null);
  constructor(private concertService: ConcertService) {}

  async ngOnInit() {
    if (this.concertService.concerts$.value == null) {
      await this.concertService.getConcertData();
    }
    this.concertGroupeds$.next(
      this.concertService.concertsPure$.value.reduce(
        (acc: ConcertGrouped[], concert) => {
          if (!acc.find((x) => x.GROUPID == concert.GROUPID))
            acc.push({
              GROUPID: concert.GROUPID,
              GROUPNAME: concert.GROUPNAME,
              GROUPIMAGEURL: concert.GROUPIMAGEURL,
              GROUPSEOURL: concert.GROUPSEOURL,
            });

          return acc;
        },
        [],
      ),
    );
  }
}
